import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSplit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="split"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C12.4142 2 12.75 2.33579 12.75 2.75V21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25V2.75C11.25 2.33579 11.5858 2 12 2ZM2 5.75C2 4.7835 2.7835 4 3.75 4H9V20H3.75C2.7835 20 2 19.2165 2 18.25V5.75ZM15 4H20.25C21.2165 4 22 4.7835 22 5.75V18.25C22 19.2165 21.2165 20 20.25 20H15V4Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSplit;
